import { blotterPreferenceStatePersistenceApiConnector } from 'apiConnector/blotters';
import { toBlotterPreferences } from 'epic/blotters/shared/preferenceState/preferenceStateEpics.helper';
import { ofType } from 'redux-observable';
import { catchError, debounceTime, EMPTY, filter, map, mergeMap, of, SchedulerLike, take, withLatestFrom } from 'rxjs';
import {
  tradesBlottersPreferenceStateGet,
  tradesBlottersPreferenceStateLoaded,
  tradesBlottersPreferenceStateLoadingFailed,
  tradesBlottersPreferenceStatePersisted,
} from 'state/blotters/trades/tradesBlotters.actions';
import {
  selectTradesBlottersCanSaveBlotterPreferences,
  selectTradesBlottersPreferenceState,
} from 'state/blotters/trades/tradesBlotters.selector';
import { ALL_TRADE_BLOTTER_TYPES } from 'state/blotters/trades/types/types';
import { EpicWithThunk } from 'state/state.common';

export function persistPreferenceStateEpic(): EpicWithThunk {
  return (action$, state$) =>
    action$.pipe(
      ofType('TRADES_BLOTTERS_ITEMS_PER_PAGE_CHANGED', 'TRADES_BLOTTERS_COLUMN_STATE_CHANGED'),
      withLatestFrom(state$),
      mergeMap(([{ blotter }, state]) => {
        const blotterPreferenceState = selectTradesBlottersPreferenceState(state, blotter);
        return of(tradesBlottersPreferenceStatePersisted(blotterPreferenceState, blotter));
      }),
    );
}
export function tradesBlottersFilterEnabledEpic(): EpicWithThunk[] {
  return ALL_TRADE_BLOTTER_TYPES.map(
    blotter => (actions$, _state$, _extra) =>
      actions$.pipe(
        ofType('TRADES_BLOTTERS_COLUMN_DEFINITION_RECEIVED'),
        filter(action => action.blotter === blotter),
        take(1),
        map(_ => tradesBlottersPreferenceStateGet(blotter)),
      ),
  );
}

export function tradesBlottersLoadPreferenceStateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      ofType('TRADES_BLOTTERS_PREFERENCE_STATE_GET'),
      mergeMap(({ blotter }) => {
        return blotterPreferenceStatePersistenceApiConnector(httpClient)
          .getState(blotter)
          .pipe(
            map(response => tradesBlottersPreferenceStateLoaded(blotter, toBlotterPreferences(response))),
            catchError(() => {
              return of(tradesBlottersPreferenceStateLoadingFailed(blotter));
            }),
          );
      }),
    );
}

export function tradesBlottersPersistPreferenceStateEpic(
  aggregationFrequency: number = 1000,
  scheduler?: SchedulerLike,
): EpicWithThunk {
  return (actions$, state$, { httpClient }) =>
    actions$.pipe(
      ofType('TRADES_BLOTTERS_PREFERENCE_STATE_PERSISTED'),
      withLatestFrom(state$),
      filter(([{ blotter }, state]) => selectTradesBlottersCanSaveBlotterPreferences(state, blotter)),
      debounceTime(aggregationFrequency, scheduler),
      mergeMap(([{ blotter, blotterPreferenceState }]) => {
        return blotterPreferenceStatePersistenceApiConnector(httpClient)
          .saveState(blotterPreferenceState, blotter)
          .pipe(catchError(_ => EMPTY));
      }),
    );
}
